<template>
  <div class="heatTreatmentInstant">
    <b-container class="bv-example-row px-0">
      <b-row class="mx-0">
        <div style="width:100vw">
          <b-row class="mx-0 mb-3">
            <b-col cols="12">
              <b-row class="mx-0">
                <b-col
                  cols="12"
                  class="p-0 m-0 mt-4"
                  style="font-size: 3rem; color: #000000"
                >
                  <!-- style="font-size: 1.75rem; color: #000000" -->
                  <span class="m-auto">即時參數顯示</span>
                </b-col>

                <!-- <b-row class="mx-0 mb-3"> -->
                <b-col cols="12" class="p-0 text-left">
                  <b-row class="mx-0 mb-3">
                    <div class="mr-4" style="width: 16rem">
                      <p class style="margin-bottom: 0.625rem;font-size: 2rem;">
                        製程
                      </p>
                      <b-form-select
                        v-model="processSelected"
                        :options="htProcessOption"
                        class=""
                        style="
                          max-width: 16rem;
                          height: 3.75rem;
                          line-height: 2.75rem;
                          font-size: 2rem;
                          border: 2px solid rgb(255, 255, 255);
                          box-shadow: rgba(0, 0, 0, 0.2) 0px 1px 3px 0px;
                          color: rgb(95, 95, 95);
                        "
                      >
                        <!-- This slot appears above the options from 'options' prop -->
                        <template #first>
                          <b-form-select-option :value="null" disabled
                            >-- 選擇製程 --</b-form-select-option
                          >
                        </template>
                      </b-form-select>
                    </div>
                    <div class="mr-4" style="width: 8.5rem">
                      <b-button
                        class="p-0"
                        @click="
                          (userSelected = processSelected),
                            (htItem = []),
                            queryData()
                        "
                        style="
                          margin-top: 60px;
                          background-color: #4b8c80;
                          width: 8.5rem;
                          height: 3.5rem;
                          font-size: 2.25rem;
                        "
                        >確定</b-button
                      >
                    </div>
                  </b-row>
                </b-col>
                <!-- </b-row> -->
                <!-- <b-row class="mx-0"> -->
                <b-col
                  cols="12"
                  class="px-0 text-right my-2"
                  style="font-size: 2rem"
                >
                  <span class="my-0" id="heattreatmentinstant-update-time"
                    >更新時間:</span
                  >
                  <span class="my-0" for="heattreatmentinstant-update-time">
                    {{ nowtime }}
                  </span>
                </b-col>
                <b-col
                  cols="12"
                  class="px-0 my-2"
                  style="overflow: auto;"
                >
                  <table class="ht-instant-table">
                    <thead class="sticky-thead">
                      <tr>
                        <template v-if="userSelected == 'factory_one-7'">
                          <th v-for="(item, index) in htOneFields" :key="index">
                            <div v-html="item.html"></div>
                          </th>
                        </template>
                        <template v-else-if="userSelected == 'factory_two-7'">
                          <th v-for="(item, index) in htTwoFields" :key="index">
                            <div v-html="item.html"></div>
                          </th>
                        </template>
                        <template v-else>
                          <th v-for="(item, index) in htOneFields" :key="index">
                            <div v-html="item.html"></div>
                          </th>
                        </template>
                      </tr>
                    </thead>
                    <template v-if="htItem.length != 0">
                      <template v-for="item in htItem">
                        <tr>
                          <td rowspan="2" style="background-color: #ffffff">
                            {{ item.device_name }}
                          </td>
                          <td style="min-width: 70px">設定值</td>
                          <td
                            v-for="(set_item, set_key) in item.value.set"
                            :key="set_key"
                          >
                            {{ set_item }}
                          </td>
                        </tr>
                        <tr>
                          <td style="min-width: 70px">實際值</td>
                          <td
                            v-for="(act_item, act_key) in item.value.act"
                            :key="act_key"
                          >
                            {{ act_item }}
                          </td>
                        </tr>
                      </template>
                    </template>
                  </table>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </div>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  name: "heatTreatmentInstant",
  data() {
    return {
      processSelected: null,
      query_time: null,
      query_counter: 0,
      nowtime: "-",
      userSelected: null,
      htOneFields: [
        {
          key: "device_name",
          label: "機台",
          html: "機台",
          sortable: false,
          class: "font-family-dfyuanstd-w5"
        },
        {
          key: "param_name",
          label: "參數\n名稱",
          html: "參數<br>名稱",
          sortable: false,
          class: "font-family-dfyuanstd-w5"
        },
        {
          key: "quench_furn_temp1",
          label: "焠火\n1區T",
          html: "焠火<br>1區T",
          sortable: false,
          class: "font-family-dfyuanstd-w5"
        },
        {
          key: "quench_furn_temp2",
          label: "焠火\n2區T",
          html: "焠火<br>2區T",
          sortable: false,
          class: "font-family-dfyuanstd-w5"
        },
        {
          key: "quench_furn_temp3",
          label: "焠火\n3區T",
          html: "焠火<br>3區T",
          sortable: false,
          class: "font-family-dfyuanstd-w5"
        },
        {
          key: "quench_furn_temp4",
          label: "焠火\n4區T",
          html: "焠火<br>4區T",
          sortable: false,
          class: "font-family-dfyuanstd-w5"
        },
        {
          key: "quench_furn_temp5",
          label: "焠火\n5區T",
          html: "焠火<br>5區T",
          sortable: false,
          class: "font-family-dfyuanstd-w5"
        },
        {
          key: "quench_furn_temp6",
          label: "焠火\n6區T",
          html: "焠火<br>6區T",
          sortable: false,
          class: "font-family-dfyuanstd-w5"
        },
        {
          key: "tempering_furn_temp1",
          label: "回火\n1區T",
          html: "回火<br>1區T",
          sortable: false,
          class: "font-family-dfyuanstd-w5"
        },
        {
          key: "tempering_furn_temp2",
          label: "回火\n2區T",
          html: "回火<br>2區T",
          sortable: false,
          class: "font-family-dfyuanstd-w5"
        },
        {
          key: "tempering_furn_temp3",
          label: "回火\n3區T",
          html: "回火<br>3區T",
          sortable: false,
          class: "font-family-dfyuanstd-w5"
        },
        {
          key: "tempering_furn_temp4",
          label: "回火\n4區T",
          html: "回火<br>4區T",
          sortable: false,
          class: "font-family-dfyuanstd-w5"
        },
        {
          key: "tempering_furn_temp5",
          label: "回火\n5區T",
          html: "回火<br>5區T",
          sortable: false,
          class: "font-family-dfyuanstd-w5"
        },
        {
          key: "quench_tank_temp",
          label: "焠火\n槽T",
          html: "焠火槽<br>T",
          sortable: false,
          class: "font-family-dfyuanstd-w5"
        },
        {
          key: "cln_bf_temp",
          label: "前清\n洗T",
          html: "前清洗<br>T",
          sortable: false,
          class: "font-family-dfyuanstd-w5"
        },
        {
          key: "cln_af_temp",
          label: "後清\n洗T",
          html: "後清洗<br>T",
          sortable: false,
          class: "font-family-dfyuanstd-w5"
        },
        {
          key: "cp1",
          label: "碳勢1",
          html: "碳勢1",
          sortable: false,
          class: "font-family-dfyuanstd-w5"
        },
        {
          key: "cp2",
          label: "碳勢2",
          html: "碳勢2",
          sortable: false,
          class: "font-family-dfyuanstd-w5"
        }
      ],
      htTwoFields: [
        {
          key: "device_name",
          label: "機台",
          html: "機台",
          sortable: false,
          class: "font-family-dfyuanstd-w5"
        },
        {
          key: "param_name",
          label: "參數\n名稱",
          html: "參數<br>名稱",
          sortable: false,
          class: "font-family-dfyuanstd-w5"
        },
        {
          key: "quench_furn_temp1",
          label: "焠火\n1區T",
          html: "焠火<br>1區T",
          sortable: false,
          class: "font-family-dfyuanstd-w5"
        },
        {
          key: "quench_furn_temp2",
          label: "焠火\n2區T",
          html: "焠火<br>2區T",
          sortable: false,
          class: "font-family-dfyuanstd-w5"
        },
        {
          key: "quench_furn_temp3",
          label: "焠火\n3區T",
          html: "焠火<br>3區T",
          sortable: false,
          class: "font-family-dfyuanstd-w5"
        },
        {
          key: "quench_furn_temp4",
          label: "焠火\n4區T",
          html: "焠火<br>4區T",
          sortable: false,
          class: "font-family-dfyuanstd-w5"
        },
        {
          key: "quench_furn_temp5",
          label: "焠火\n5區T",
          html: "焠火<br>5區T",
          sortable: false,
          class: "font-family-dfyuanstd-w5"
        },
        {
          key: "quench_furn_temp6",
          label: "焠火\n6區T",
          html: "焠火<br>6區T",
          sortable: false,
          class: "font-family-dfyuanstd-w5"
        },
        {
          key: "quench_furn_temp7",
          label: "焠火\n7區T",
          html: "焠火<br>7區T",
          sortable: false,
          class: "font-family-dfyuanstd-w5"
        },
        {
          key: "tempering_furn_temp1",
          label: "回火\n1區T",
          html: "回火<br>1區T",
          sortable: false,
          class: "font-family-dfyuanstd-w5"
        },
        {
          key: "tempering_furn_temp2",
          label: "回火\n2區T",
          html: "回火<br>2區T",
          sortable: false,
          class: "font-family-dfyuanstd-w5"
        },
        {
          key: "tempering_furn_temp3",
          label: "回火\n3區T",
          html: "回火<br>3區T",
          sortable: false,
          class: "font-family-dfyuanstd-w5"
        },
        {
          key: "tempering_furn_temp4",
          label: "回火\n4區T",
          html: "回火<br>4區T",
          sortable: false,
          class: "font-family-dfyuanstd-w5"
        },
        {
          key: "tempering_furn_temp5",
          label: "回火\n5區T",
          html: "回火<br>5區T",
          sortable: false,
          class: "font-family-dfyuanstd-w5"
        },
        {
          key: "quench_tank_temp",
          label: "焠火\n槽T",
          html: "焠火槽<br>T",
          sortable: false,
          class: "font-family-dfyuanstd-w5"
        },
        {
          key: "dryer_cln_bf_temp",
          label: "前烘\n乾T",
          html: "前烘乾<br>T",
          sortable: false,
          class: "font-family-dfyuanstd-w5"
        },
        {
          key: "cln_bf_temp",
          label: "前清\n洗T",
          html: "前清洗<br>T",
          sortable: false,
          class: "font-family-dfyuanstd-w5"
        },
        {
          key: "cln_af_temp",
          label: "後清\n洗T",
          html: "後清洗<br>T",
          sortable: false,
          class: "font-family-dfyuanstd-w5"
        },
        {
          key: "cp1",
          label: "碳勢1",
          html: "碳勢1",
          sortable: false,
          class: "font-family-dfyuanstd-w5"
        },
        {
          key: "cp2",
          label: "碳勢2",
          html: "碳勢2",
          sortable: false,
          class: "font-family-dfyuanstd-w5"
        }
      ],
      htItem: [
        // {
        //   value: {
        //     act: {
        //       quench_furn_temp1: 252,
        //       quench_furn_temp2: 265,
        //       quench_furn_temp3: 295,
        //       quench_furn_temp4: 298,
        //       quench_furn_temp5: 316,
        //       quench_furn_temp6: 288,
        //       tempering_furn_temp1: 40,
        //       tempering_furn_temp2: 40,
        //       tempering_furn_temp3: 41,
        //       tempering_furn_temp4: 41,
        //       tempering_furn_temp5: 43,
        //       quench_tank_temp: 45,
        //       dryer_cln_bf_temp: 32,
        //       cln_bf_temp: 39,
        //       cln_af_temp: 37,
        //       cp1: 0,
        //       cp2: 0
        //     },
        //     set: {
        //       quench_furn_temp1: 100,
        //       quench_furn_temp2: 100,
        //       quench_furn_temp3: 100,
        //       quench_furn_temp4: 100,
        //       quench_furn_temp5: 100,
        //       quench_furn_temp6: 100,
        //       tempering_furn_temp1: 100,
        //       tempering_furn_temp2: 100,
        //       tempering_furn_temp3: 100,
        //       tempering_furn_temp4: 100,
        //       tempering_furn_temp5: 100,
        //       quench_tank_temp: 75,
        //       dryer_cln_bf_temp: 30,
        //       cln_bf_temp: 65,
        //       cln_af_temp: 65,
        //       cp1: 0.28,
        //       cp2: 0.28
        //     }
        //   },
        //   device_name: "A2"
        // }
      ]
    };
  },
  created: function() {
    this.change_selectPage("heattreatmentinstant");
    this.change_selectPageName(this.pageName.heattreatmentinstant);
    window.addEventListener("beforeunload", this.setSessionItems);
    let userSelected = sessionStorage.getItem(
      "mes_heattreatmentinstant_userSelected"
    );
    if (userSelected != null) {
      this.processSelected = userSelected;
      this.userSelected = userSelected;
      this.queryData();
    }
    sessionStorage.removeItem("mes_heattreatmentinstant_userSelected");
  },
  mounted: function() {},
  components: {},
  watch: {
    query_counter: {
      handler() {
        let vm = this;
        if (vm.query_counter >= 1500) {
          window.location.reload();
        }
      }
    }
  },
  computed: {
    ...mapGetters({
      axiosResult: "commonaxios/get_axiosResult",
      selectPage: "getlogin/get_selectPage",
      pageName: "getlogin/get_pageName",
      htProcessOption: "commonqueryiot/get_htProcessOption"
    })
  },
  methods: {
    ...mapActions({
      axiosAction: "commonaxios/axiosAction",
      change_selectPage: "getlogin/change_selectPage",
      change_selectPageName: "getlogin/change_selectPageName"
    }),
    queryData() {
      let vm = this;
      if (vm.selectPage != "heattreatmentinstant") {
        return;
      }
      if (vm.userSelected == null) {
        return;
      }
      this.clearTimer();
      // vm.trigger_loadScreenModal();
      var params = {};
      params["vuePage"] = vm.selectPage;
      params["methods"] = "GET";
      params["whichFunction"] = "instantQuery";
      params["process"] = vm.userSelected;
      vm.query_time = new Date();
      vm.axiosAction(params).then(() => {
        // vm.trigger_loadScreenModal();
        var result = vm.axiosResult;
        console.log(result);
        if (result.Response == "ok") {
          if (result.process == vm.userSelected) {
            let result_data = result["QueryTableData"];
            vm.htItem = result_data;
          }
        }
        vm.query_counter++;
        vm.getNowTime();
        if (vm.query_time != null) {
          vm.query_time = null;
          setTimeout(function() {
            vm.queryData();
          }, 1000);
        }
      });
    },
    clearTimer() {
      var highestIntervalId = setInterval(";");
      for (var i = 0; i < highestIntervalId; i++) {
        //清除所有計時資料
        clearInterval(i);
      }
    },

    getNowTime() {
      let vm = this;
      let Today = new Date();
      vm.nowtime =
        Today.getFullYear() +
        "-" +
        String(Today.getMonth() + 1).padStart(2, "0") +
        "-" +
        String(Today.getDate()).padStart(2, "0") +
        " " +
        String(Today.getHours()).padStart(2, "0") +
        ":" +
        String(Today.getMinutes()).padStart(2, "0") +
        ":" +
        String(Today.getSeconds()).padStart(2, "0");
      console.log(vm.nowtime);
    },
    //資料reset
    reset(keep) {
      var def = this.$options.data();
      for (var i = 0; i < keep.length; i++) {
        def[keep[i]] = this[keep[i]];
      }
      Object.assign(this.$data, def);
      //https://codepen.io/karimcossutti/pen/ObXyKq
    },
    setSessionItems() {
      if (this.userSelected != null) {
        sessionStorage.setItem(
          "mes_heattreatmentinstant_userSelected",
          this.userSelected
        );
      }
    }
  },
  destroyed() {
    window.removeEventListener("beforeunload", this.setSessionItems);
    this.clearTimer();
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
<style lang="scss">
.ht-instant-table {
  width: 100%;
  min-width: 900px;
  border-collapse: separate;
  border-spacing: 0;
  border: 1px solid #000;
  font-size: 1.75rem;
}

.ht-instant-table td {
  vertical-align: middle !important;
  border: 1px solid #000;
  font-weight: bold;
}

.ht-instant-table tr:nth-child(odd) {
  color: #4b8c80;
  background-color: #ffffff;
}
.ht-instant-table tr:nth-child(even) {
  background-color: #f0f0f0;
}

.ht-instant-table thead th {
  padding: 5px;
  color: #ffffff;
  background-color: #4b8c80;
  vertical-align: middle !important;
  min-width: 60px;
  border: 1px solid #000;
}
.sticky-thead {
  position: sticky;
  top: 0;
}
</style>



// WEBPACK FOOTER //
// src/views/heattreatmentinstant.vue